export interface TimeProvider {
    getTime(): number;
}

export class TimeProviderImpl implements TimeProvider {
    public getTime(): number {
        return new Date().getTime();
    }
}
